import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';
var renderIcon = function renderIcon(active, selected, valid, index) {
  if (selected) {
    return /*#__PURE__*/React.createElement("i", {
      className: "fa fa-dot-circle"
    });
  }
  if (active && valid) {
    return /*#__PURE__*/React.createElement("i", {
      className: "fa fa-check-circle"
    });
  }
  if (active && !valid) {
    return /*#__PURE__*/React.createElement("i", {
      className: "fa fa-exclamation-circle"
    });
  }
  return /*#__PURE__*/React.createElement("span", {
    className: "badge"
  }, index + 1);
};
function TitleTabBar(_ref) {
  var style = _ref.style,
    title = _ref.title,
    tabs = _ref.tabs,
    toggleTab = _ref.toggleTab,
    selectedTab = _ref.selectedTab,
    activeTab = _ref.activeTab,
    errors = _ref.errors,
    tabTitles = _ref.tabTitles;
  return /*#__PURE__*/React.createElement("div", {
    className: "sticky-title",
    style: _objectSpread(_objectSpread({}, style), {}, {
      top: 52,
      width: style.width + 30 || null
    })
  }, /*#__PURE__*/React.createElement("h2", {
    className: "demibold"
  }, "".concat(title, " - ").concat(tabTitles[selectedTab])), /*#__PURE__*/React.createElement("span", {
    className: "body-text-3"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-info-circle"
  }), "\xA0All questions are required unless otherwise specified"), /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-1 tabs mt-4"
  }, tabs.map(function (tab, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "col",
      key: tab
    }, /*#__PURE__*/React.createElement("div", {
      className: "tab ".concat(activeTab !== null && index <= activeTab ? 'active ' : '', " ").concat(index === selectedTab ? 'selected' : '', " ").concat(errors["".concat(tab, "_errors_count").toLowerCase()] > 0 ? 'invalid' : ''),
      id: "create-proposal-tab-".concat(index)
    }, renderIcon(activeTab != null && index <= activeTab, index === selectedTab, !errors["".concat(tab, "_errors_count").toLowerCase()] > 0, index), /*#__PURE__*/React.createElement("a", {
      href: "tab",
      className: "body-text-3 medium",
      key: tab,
      onClick: function onClick(e) {
        return toggleTab(e, index);
      }
    }, tab)));
  })));
}
TitleTabBar.defaultProps = {
  style: {},
  title: '',
  errors: {},
  activeTab: null
};
TitleTabBar.propTypes = {
  style: PropTypes.shape({}),
  title: PropTypes.string,
  tabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  tabTitles: PropTypes.arrayOf(PropTypes.string).isRequired,
  toggleTab: PropTypes.func.isRequired,
  selectedTab: PropTypes.number.isRequired,
  errors: PropTypes.shape({}),
  activeTab: PropTypes.number
};
export default TitleTabBar;